export type Video = {
  id: string;
  title: string;
  category: "movie" | "short" | "hot";
  year: number;
  region: string;
  duration: string;
  director: string;
  views: number;
  favorites: number;
  rating: number;
  tags: string[];
  summary: string;
  cover: string;
  publishedAt: string;
};

export const videos: Video[] = [
  {
    id: "mv-001",
    title: "夜航西飞",
    category: "movie",
    year: 2026,
    region: "中国",
    duration: "128分钟",
    director: "陈牧",
    views: 1284000,
    favorites: 46200,
    rating: 8.9,
    tags: ["剧情", "公路", "公路片", "夜色"],
    summary:
      "一名长途货车司机在西北公路上接到一单临时运输任务，副驾上多了一位不愿透露目的地的陌生乘客。三天两夜的行程里，两个人用零碎的对话拼出各自不愿回头的过去。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20lone%20vintage%20truck%20on%20an%20empty%20desert%20highway%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20amber%20horizon%20glow%2C%20fine%20film%20grain%2C%20moody%20atmospheric%20composition%2C%20no%20text%2C%20muted%20teal%20shadows%20and%20soft%20golden%20highlights%2C%20widescreen&width=800&height=450&seq=video-mv-001&orientation=landscape",
    publishedAt: "2026-10-15",
  },
  {
    id: "mv-002",
    title: "长街旧梦",
    category: "movie",
    year: 2025,
    region: "中国",
    duration: "112分钟",
    director: "林知远",
    views: 962000,
    favorites: 33800,
    rating: 8.6,
    tags: ["剧情", "年代", "家庭", "城市记忆"],
    summary:
      "老城区改造前的最后一个夏天，一间开了三十年的照相馆准备关门。店主翻出压在柜底的底片，一段被全家刻意遗忘的往事重新浮出水面。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20old%20street%20photo%20studio%20with%20wooden%20cabinets%20and%20hanging%20negatives%2C%20warm%20amber%20lamp%20light%20against%20dusty%20navy%20blue%20walls%2C%20nostalgic%20melancholic%20mood%2C%20no%20text%2C%20soft%20grain%20and%20shallow%20depth%20of%20field%2C%20widescreen&width=800&height=450&seq=video-mv-002&orientation=landscape",
    publishedAt: "2026-10-12",
  },
  {
    id: "mv-003",
    title: "深海回声",
    category: "movie",
    year: 2026,
    region: "美国",
    duration: "134分钟",
    director: "Elena Marsh",
    views: 1542000,
    favorites: 57400,
    rating: 9.1,
    tags: ["科幻", "悬疑", "深海", "科幻片"],
    summary:
      "深海监测站接收到一段不该存在的规律声波，值守的三名研究员必须在氧气耗尽前判断：那是地质活动，还是某种回应。封闭空间里的信任开始一寸寸崩塌。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20inside%20a%20deep%20sea%20research%20station%20with%20round%20porthole%20windows%2C%20cold%20navy%20blue%20underwater%20glow%20mixed%20with%20faint%20amber%20instrument%20lights%2C%20sci-fi%20suspense%20atmosphere%2C%20no%20text%2C%20cinematic%20grain%20and%20volumetric%20haze%2C%20widescreen&width=800&height=450&seq=video-mv-003&orientation=landscape",
    publishedAt: "2026-10-14",
  },
  {
    id: "mv-004",
    title: "白昼流星",
    category: "movie",
    year: 2024,
    region: "中国",
    duration: "106分钟",
    director: "苏睿",
    views: 738000,
    favorites: 25900,
    rating: 8.3,
    tags: ["剧情", "成长", "小镇"],
    summary:
      "高考结束后的夏天，两个小镇少年决定骑车去看一场只有在白天才能观测到的流星雨。路上遇见的人，比他们想象中更接近自己的未来。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20two%20teenagers%20with%20bicycles%20on%20a%20small%20town%20road%2C%20bright%20pale%20daylight%2C%20slight%20navy%20blue%20sky%20tone%20and%20warm%20amber%20sunlight%20on%20their%20shoulders%2C%20coming%20of%20age%20mood%2C%20no%20text%2C%20soft%20film%20grain%2C%20widescreen&width=800&height=450&seq=video-mv-004&orientation=landscape",
    publishedAt: "2026-09-26",
  },
  {
    id: "mv-005",
    title: "东京雨停之前",
    category: "movie",
    year: 2025,
    region: "日本",
    duration: "118分钟",
    director: "佐野洋介",
    views: 881000,
    favorites: 41200,
    rating: 8.7,
    tags: ["爱情", "城市", "雨天"],
    summary:
      "梅雨季的东京，一家只剩最后一位客人的旧书店。店主每晚打烊前都会多留一盏灯，等一个只在雨天出现的人。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20tiny%20Tokyo%20bookshop%20on%20a%20rainy%20evening%2C%20wet%20pavement%20reflecting%20warm%20amber%20lantern%20light%20against%20navy%20blue%20dusk%2C%20quiet%20romantic%20mood%2C%20no%20text%2C%20shallow%20depth%20of%20field%20and%20gentle%20rain%20streaks%2C%20widescreen&width=800&height=450&seq=video-mv-005&orientation=landscape",
    publishedAt: "2026-09-30",
  },
  {
    id: "mv-006",
    title: "第七号站台",
    category: "movie",
    year: 2023,
    region: "英国",
    duration: "99分钟",
    director: "Oliver Grant",
    views: 645000,
    favorites: 21800,
    rating: 8.2,
    tags: ["悬疑", "推理", "列车"],
    summary:
      "午夜末班车之后，一个废弃站台的时钟每天都停在同一个时刻。记者循着旧报纸里的失踪案回到这里，发现站台上等待的人从未离开。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20abandoned%20British%20railway%20platform%20at%20midnight%2C%20fog%20and%20dim%20amber%20lamps%20against%20deep%20navy%20darkness%2C%20eerie%20mystery%20tension%2C%20no%20text%2C%20desaturated%20cool%20tones%20with%20small%20warm%20accents%2C%20widescreen&width=800&height=450&seq=video-mv-006&orientation=landscape",
    publishedAt: "2026-09-18",
  },
  {
    id: "mv-007",
    title: "山与海的距离",
    category: "movie",
    year: 2024,
    region: "韩国",
    duration: "121分钟",
    director: "朴在勋",
    views: 692000,
    favorites: 24500,
    rating: 8.4,
    tags: ["剧情", "家庭", "海岛"],
    summary:
      "在渔村独自生活的老人，收到一封来自多年未见女儿的信。他带上腌了整年的酱货，坐了两天车，去往一座完全陌生的城市。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20fishing%20village%20harbor%20at%20blue%20hour%2C%20small%20wooden%20boats%20and%20warm%20amber%20window%20lights%2C%20distant%20misty%20mountains%2C%20navy%20blue%20water%2C%20gently%20melancholic%20family%20drama%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-mv-007&orientation=landscape",
    publishedAt: "2026-09-08",
  },
  {
    id: "mv-008",
    title: "霓虹背面",
    category: "movie",
    year: 2026,
    region: "中国",
    duration: "116分钟",
    director: "何舟",
    views: 1103000,
    favorites: 38700,
    rating: 8.8,
    tags: ["犯罪", "悬疑", "都市"],
    summary:
      "一间二十四小时营业的洗衣店，是整条街最不起眼的角落。当夜班店员发现衣物里夹带的物品，他被卷进一场无法退出的交易。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%2024-hour%20laundromat%20at%20night%20with%20glowing%20amber%20sign%20and%20cold%20navy%20blue%20street%20reflections%2C%20urban%20crime%20thriller%20mood%2C%20wet%20asphalt%2C%20no%20text%2C%20high%20contrast%20lighting%20and%20film%20grain%2C%20widescreen&width=800&height=450&seq=video-mv-008&orientation=landscape",
    publishedAt: "2026-10-09",
  },
  {
    id: "mv-009",
    title: "最后一班渡轮",
    category: "movie",
    year: 2022,
    region: "法国",
    duration: "108分钟",
    director: "Camille Roche",
    views: 486000,
    favorites: 17800,
    rating: 8.0,
    tags: ["文艺", "海岛", "离别"],
    summary:
      "渡轮即将停航的那个秋天，岛上的邮差开始把积攒了二十年的信一封封送出去。收信的人有的还在，有的早已搬走。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20small%20ferry%20leaving%20a%20quiet%20island%20dock%20at%20sunset%2C%20deep%20navy%20sea%20with%20warm%20amber%20sky%20band%2C%20minimal%20melancholic%20art%20house%20composition%2C%20no%20text%2C%20soft%20grain%20and%20calm%20horizon%2C%20widescreen&width=800&height=450&seq=video-mv-009&orientation=landscape",
    publishedAt: "2026-08-22",
  },
  {
    id: "sh-001",
    title: "七分钟的城市",
    category: "short",
    year: 2026,
    region: "中国",
    duration: "7分钟",
    director: "陆晨",
    views: 421000,
    favorites: 16400,
    rating: 8.5,
    tags: ["实验", "城市", "长镜头"],
    summary:
      "一个长镜头穿过清晨的地铁口、早餐摊和写字楼大堂，记录一座城市醒来的七分钟。没有台词，只有环境和呼吸。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20still%20of%20a%20city%20subway%20entrance%20at%20early%20morning%2C%20commuters%20in%20soft%20motion%20blur%2C%20cool%20navy%20blue%20shadows%20and%20warm%20amber%20street%20food%20light%2C%20documentary%20observation%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-sh-001&orientation=landscape",
    publishedAt: "2026-10-11",
  },
  {
    id: "sh-002",
    title: "拾光",
    category: "short",
    year: 2025,
    region: "中国",
    duration: "12分钟",
    director: "周意",
    views: 358000,
    favorites: 13900,
    rating: 8.3,
    tags: ["温情", "家庭", "回忆"],
    summary:
      "孙女替眼睛不好的外婆整理旧相册，每一张照片背后的故事都被重新讲了一遍。有些记忆被说错了很多次，但从来没有人纠正。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20still%20of%20an%20elderly%20woman%20and%20granddaughter%20looking%20at%20old%20photo%20albums%20by%20a%20window%2C%20warm%20amber%20afternoon%20light%20with%20navy%20blue%20shadows%2C%20tender%20intimate%20mood%2C%20no%20text%2C%20shallow%20depth%20of%20field%2C%20widescreen&width=800&height=450&seq=video-sh-002&orientation=landscape",
    publishedAt: "2026-09-28",
  },
  {
    id: "sh-003",
    title: "玻璃海",
    category: "short",
    year: 2025,
    region: "日本",
    duration: "9分钟",
    director: "高桥悠",
    views: 512000,
    favorites: 22600,
    rating: 8.8,
    tags: ["动画", "海洋", "手绘"],
    summary:
      "手绘动画短片。一个住在玻璃瓶里的少年，每天把海的声音装进瓶子寄给远方。直到有一天，瓶子被海浪送了回来。",
    cover:
      "https://readdy.ai/api/search-image?query=Hand-drawn%20animated%20short%20film%20still%20of%20a%20boy%20inside%20a%20giant%20glass%20bottle%20floating%20on%20a%20calm%20sea%2C%20deep%20navy%20blue%20water%20and%20warm%20amber%20sunset%20reflections%2C%20dreamy%20illustrated%20texture%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-sh-003&orientation=landscape",
    publishedAt: "2026-10-01",
  },
  {
    id: "sh-004",
    title: "午夜便利店",
    category: "short",
    year: 2024,
    region: "韩国",
    duration: "15分钟",
    director: "金度允",
    views: 389000,
    favorites: 14200,
    rating: 8.1,
    tags: ["剧情", "夜晚", "日常"],
    summary:
      "凌晨三点的便利店，值夜班的店员和三个常客。他们从不交谈，却记得彼此买的东西。这一夜，其中一个人没有出现。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20still%20of%20a%20small%20convenience%20store%20interior%20at%203am%2C%20fluorescent%20cool%20light%20mixed%20with%20warm%20amber%20shelf%20glow%2C%20empty%20street%20through%20the%20glass%2C%20lonely%20urban%20night%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-sh-004&orientation=landscape",
    publishedAt: "2026-09-20",
  },
  {
    id: "sh-005",
    title: "纸上飞行",
    category: "short",
    year: 2026,
    region: "中国",
    duration: "6分钟",
    director: "沈亦",
    views: 466000,
    favorites: 19800,
    rating: 8.6,
    tags: ["动画", "纸艺", "治愈"],
    summary:
      "定格纸艺短片。一张被写上愿望的纸飞机，从教室窗口飞出，穿过整座城市，最后落在一个完全没有想过的人手里。",
    cover:
      "https://readdy.ai/api/search-image?query=Stop-motion%20paper%20craft%20short%20film%20still%20of%20a%20folded%20paper%20airplane%20flying%20over%20a%20miniature%20navy%20blue%20city%20with%20warm%20amber%20window%20lights%2C%20handmade%20texture%2C%20whimsical%20gentle%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-sh-005&orientation=landscape",
    publishedAt: "2026-10-07",
  },
  {
    id: "sh-006",
    title: "潮汐之间",
    category: "short",
    year: 2023,
    region: "美国",
    duration: "11分钟",
    director: "Noah Reed",
    views: 274000,
    favorites: 9600,
    rating: 7.9,
    tags: ["纪录片", "海岸", "自然"],
    summary:
      "一位在海岸测量潮位四十年的观测员，用一本手写记录本留下了海岸线后退的全部证据。短片跟拍他最后一次完成例行测量。",
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20short%20film%20still%20of%20a%20lone%20coastal%20surveyor%20with%20a%20notebook%20standing%20on%20a%20rocky%20shore%2C%20overcast%20navy%20blue%20sea%20and%20faint%20warm%20amber%20horizon%2C%20restrained%20natural%20light%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-sh-006&orientation=landscape",
    publishedAt: "2026-09-12",
  },
  {
    id: "ht-001",
    title: "城市漫游计划",
    category: "hot",
    year: 2026,
    region: "中国",
    duration: "45分钟",
    director: "顾行",
    views: 2260000,
    favorites: 84200,
    rating: 9.0,
    tags: ["纪录片", "城市", "人文"],
    summary:
      "不带攻略，不设定目的地，只凭一条公交线路走完一座城市。本集从终点站出发，记录沿途下车的人和他们停留的理由。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20still%20of%20a%20city%20bus%20interior%20at%20golden%20hour%2C%20passengers%20silhouettes%2C%20warm%20amber%20light%20through%20windows%20with%20deep%20navy%20blue%20shadows%2C%20observational%20humanist%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-ht-001&orientation=landscape",
    publishedAt: "2026-10-16",
  },
  {
    id: "ht-002",
    title: "街头味觉地图",
    category: "hot",
    year: 2025,
    region: "中国",
    duration: "38分钟",
    director: "蔡晚",
    views: 1935000,
    favorites: 72600,
    rating: 8.9,
    tags: ["美食", "城市", "人文"],
    summary:
      "一条街、六家小店、四十年。镜头跟着一位老食客重走他年轻时上夜班的路线，把味道和人的记忆一起端上桌。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20food%20documentary%20still%20of%20a%20steaming%20street%20food%20stall%20at%20night%2C%20warm%20amber%20cooking%20light%20against%20deep%20navy%20blue%20street%2C%20hands%20preparing%20food%2C%20appetizing%20detail%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-ht-002&orientation=landscape",
    publishedAt: "2026-10-10",
  },
  {
    id: "ht-003",
    title: "野外观星指南",
    category: "hot",
    year: 2025,
    region: "美国",
    duration: "52分钟",
    director: "Daniel Cole",
    views: 1478000,
    favorites: 61200,
    rating: 8.7,
    tags: ["科普", "星空", "自然"],
    summary:
      "远离城市灯光的三处暗夜保护区，三套不同的观星方式。节目用最基础的天文知识，带人重新认识头顶那片被忽略的天空。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20still%20of%20a%20starry%20night%20sky%20over%20a%20desert%20campsite%2C%20deep%20navy%20blue%20milky%20way%20with%20small%20warm%20amber%20tent%20light%20in%20foreground%2C%20awe%20inspiring%20quiet%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-ht-003&orientation=landscape",
    publishedAt: "2026-10-04",
  },
  {
    id: "ht-004",
    title: "一百种生活",
    category: "hot",
    year: 2026,
    region: "中国",
    duration: "40分钟",
    director: "白露",
    views: 1687000,
    favorites: 69400,
    rating: 8.8,
    tags: ["人物", "纪实", "生活"],
    summary:
      "记录一百个普通人的一天。本集的主角是一位在凌晨四点开始工作的花市搬运工，他记得每一种花的脾气。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20documentary%20still%20of%20a%20flower%20market%20worker%20at%20dawn%2C%20bundles%20of%20fresh%20flowers%2C%20cool%20navy%20blue%20morning%20light%20with%20warm%20amber%20highlights%2C%20honest%20humanist%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-ht-004&orientation=landscape",
    publishedAt: "2026-10-13",
  },
  {
    id: "ht-005",
    title: "雪山下的厨房",
    category: "hot",
    year: 2024,
    region: "日本",
    duration: "47分钟",
    director: "山本直",
    views: 1126000,
    favorites: 43800,
    rating: 8.4,
    tags: ["美食", "自然", "旅行"],
    summary:
      "海拔两千米的小木屋里，一位厨师用有限的食材为登山者准备晚餐。窗外是雪山，屋内是一锅慢慢煮开的汤。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20still%20of%20a%20cozy%20mountain%20cabin%20kitchen%20with%20a%20steaming%20pot%2C%20snowy%20peaks%20outside%20the%20window%2C%20deep%20navy%20blue%20dusk%20and%20warm%20amber%20interior%20light%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-ht-005&orientation=landscape",
    publishedAt: "2026-09-24",
  },
  {
    id: "ht-006",
    title: "夜行列车实录",
    category: "hot",
    year: 2025,
    region: "英国",
    duration: "55分钟",
    director: "Ava Morris",
    views: 1339000,
    favorites: 52600,
    rating: 8.6,
    tags: ["纪录片", "列车", "夜晚"],
    summary:
      "一趟跨越整夜的列车，从始发站到终点站不剪断。乘客上车又下车，车厢里的灯光逐渐从明亮变成昏黄。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20still%20inside%20a%20night%20train%20carriage%2C%20empty%20seats%20with%20warm%20amber%20reading%20lights%20and%20deep%20navy%20blue%20windows%2C%20long%20exposure%20motion%20outside%2C%20contemplative%20mood%2C%20no%20text%2C%20widescreen&width=800&height=450&seq=video-ht-006&orientation=landscape",
    publishedAt: "2026-09-16",
  },
];